<template>
  <div id="error-logs-table">
    <!------------------------- Table  starts------------------------->
    <v-data-table
      :items="data"
      :headers="headers"
      :loading="isLoading"
      class="body-2 elevation-2"
      :options.sync="pagination"
      :footer-props="footerProps"
      :header-props="{ class: 'subtitle-2' }"
      :items-per-page="paginationMeta.itemsPerPage"
      :server-items-length="paginationMeta.serverItemsLength"
      :loading-text="$dictionary.app.common.errorLogs.loading"
      :no-data-text="$dictionary.app.common.errorLogs.errorLogs"
    >
      <template #item.created_at="{item}">
        <span class="text-eclipses">
          {{ item.created_at | formatDateToAmPm }}
        </span>
      </template>
      <template #item.mailbox_provider_name="{ item }">
        <table-matrics-row
          is-link
          is-text-pointer
          textClass="blue--text"
          :query="{ active_tab: 'profile' }"
          :text="item.mailbox_provider_name"
          :navigate-to="
            `${$paths.mailboxProviders}/${item.mailbox_provider_id}`
          "
        />
      </template>
      <template #item.source="{ item }">
        <table-matrics-row
          :is-link="isValidSeed(item)"
          :is-text-pointer="isValidSeed(item)"
          :textClass="isValidSeed(item) ? 'blue--text' : ''"
          :query="{ active_tab: 'seeds' }"
          :text="item.source"
          :navigate-to="
            `${$paths.mailboxProviders}/${item.mailbox_provider_id}`
          "
        />
      </template>

      <template #item.error_message="{item}">
        <text-ellipsis :tooltip-width="'50%'" :text="item.error_message" />
      </template>
    </v-data-table>
    <!------------------------- Table ends ------------------------->
  </div>
</template>

<script>
import { PaginationSortMixin } from "@/mixins";
import TextEllipsis from "@/components/shared/TextEllipsis.vue";
import headers from "@/data/table-headers/error-logs.headers.json";

import TableMatricsRow from "@/components/shared/TableMatricsRow.vue";

/**
 * Error logs table
 */
export default {
  name: "ErrorLogsTable",
  /**
   * ---------------- Components ------------------
   */
  components: { TextEllipsis, TableMatricsRow },
  /**
   * ---------------- Mixins ------------------
   */
  mixins: [PaginationSortMixin],
  /**
   * ---------------- Props ------------------
   */
  props: {
    data: { type: Array, required: true },
    isLoading: { type: Boolean, required: true },
  },
  /**
   * ---------------- Data properties ------------------
   */
  data() {
    return {
      defaultSortOrder: "created_at",
      sortDesc: true,
      headers,
    };
  },
  methods: {
    isValidSeed({ mailbox_provider_id }) {
      return !!mailbox_provider_id;
    },
  },
};
</script>
